import {gsap} from "gsap/all";
import $ from "jquery";
import {BaseGameBBAI} from "../base/BaseGameBBAI";
import {ScenarioAdmin} from "./components/ScenarioAdmin";

// Constructor
export class CBMSTabletApp extends BaseGameBBAI {

  constructor() {
    super(`data/cbms-tablet.json`, 'cbms');
  }

  initGame() {
    super.initGame();

    // Init scenario cards
    this.scenarioAdminCards = {};
    $(`.scenario`).each((i, scenario) => {
      const scenarioMachineName = $(scenario).data("scenario-machine-name");
      this.scenarioAdminCards[scenarioMachineName] = new ScenarioAdmin($(scenario));
    })

    this.bgTimeline = gsap.timeline({paused: true});

    this.bgTimeline.to(".main-background", {
      xPercent: -50,
      ease: "power2.inOut",
      duration: 1,
    });

    this.currentScenario = null;
  }

  initScreen(screenId) {
  }

  startApp() {
    this.sendScreenBridgeMessage(`startApp`);
    this.goToScreen(2); // Call goToScreen to here to allow the tablet to work without ScreenBridge

    this.bgTimeline.play();
  }

  onScreenBridgeMessage(messageString) {
    super.onScreenBridgeMessage(messageString);
    if (messageString.startsWith("gotoScreen")) {
      const screenId = parseInt(messageString.replace("gotoScreen ", ""));
      if (screenId === 1) this.reset(screenId);
      else if (screenId === 2) this.goToScreen(screenId);
    } else if (messageString === "lockInteraction") {
      $("body").addClass("master-app-locked");
    } else if (messageString === "unlockInteraction") {
      $("body").removeClass("master-app-locked");
    }
  }

  toggleScenario(scenario) {
    // Close previously opened scenarios
    $('.scenario.opened').each((i, n) => {
      this.scenarioAdminCards[$(n).data("scenario-machine-name")].setScenarioActions(".read-more");
    });

    // Show text, update height and update actions
    this.scenarioAdminCards[scenario].setScenarioActions(".start-button");
  }

  startScenario(scenario) {
    // skip if we are trying to start the same scenario
    if (scenario === this.currentScenario) return;

    this.currentScenario = scenario;

    this.sendScreenBridgeMessage(`startScenario ${scenario}`);

    // Updated currently started scenario
    $('.scenario.started').removeClass('started');

    // Lock all the other scenarios and reset their states
    for (const scenarioName of Object.keys(this.scenarioAdminCards)) {
      if (scenario !== scenarioName) {
        this.scenarioAdminCards[scenarioName].setScenarioActions(".read-more");
        this.scenarioAdminCards[scenarioName].lock();
      }
    }

    // Set selected scenario as started
    const $selectedScenario = $(`.scenario[data-scenario-machine-name="${scenario}"]`);
    $selectedScenario.addClass('started');
    this.scenarioAdminCards[scenario].setScenarioActions(".in-progress");
  }

  cancelScenario(scenario) {
    this.currentScenario = null;

    this.sendScreenBridgeMessage(`cancelScenario ${scenario}`);

    // Set selected scenario as not started
    const $selectedScenario = $(`.scenario[data-scenario-machine-name="${scenario}"]`);
    $selectedScenario.removeClass('started');
    this.scenarioAdminCards[scenario].setScenarioActions(".start-button");

    // Unlock all the scenarios
    for (const scenarioName of Object.keys(this.scenarioAdminCards)) {
      this.scenarioAdminCards[scenarioName].unlock();
    }
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {
    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    this.bgTimeline.reverse();

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);

    const resetCallback = () => {
      // Things that reset after goToScreen
      for (const scenarioName of Object.keys(this.scenarioAdminCards)) {
        this.scenarioAdminCards[scenarioName].reset();
      }

      this.currentScenario = null;
    }

    // Super
    return super.reset(screenId, resetCallback);
  }

}
